var exports = {
  "wx": "xfd349460--537707--header",
  "Ex": "xfd349460--537707--header--fixed",
  "C$": "xfd349460--537707--nav",
  "Qs": "xfd349460--537707--content",
  "DD": "xfd349460--537707--title",
  "O0": "xfd349460--537707--rating",
  "Ox": "xfd349460--537707--title-controls",
  "vR": "xfd349460--537707--tabs",
  "ne": "xfd349460--537707--controls",
};

module.exports = exports;
